/* @flow */

import $ from 'jquery';

import pesquisar from './pesquisar';
import gravarCookie from './gravar-cookie';

const mostrarErro = (e: Object) => global.swal({
    html: e.response.data.message,
    type: 'error',
    timer: 5000,
    confirmButtonText: 'OK',
});

const eventoSubmitLogin = () => {
    $('#tela-de-login').submit((event) => {
        event.preventDefault();

        const apelido = $('#apelido').val();
        const usuario = $('[name=usuario]').val();
        const senha = $('[name=senha]').val();

        return pesquisar({ apelido, usuario, senha })
            .then(r => gravarCookie(r.token, r.nivel))
            .catch(mostrarErro);
    });
};

export default eventoSubmitLogin;



// WEBPACK FOOTER //
// ./app/admin/login/evento-submit-no-login.js